import { SocialIconLink } from '@/components/social-networks/SocialButton'
import { ISocialPlatform } from '@/interfaces/socials'
import { useProfile } from 'containers/profile/hooks/useProfile'

const socialLoader = [
  {
    platform: ISocialPlatform.INSTAGRAM,
    identifier: 'instagram_loading',
  },
  {
    platform: ISocialPlatform.TIKTOK,
    identifier: 'tiktok_loading',
  },
  {
    platform: ISocialPlatform.YOUTUBE,
    identifier: 'youtube_loading',
  },
]

export const SocialNetworkList = () => {
  const { profile, isLoading } = useProfile()

  return (
    <div className="flex gap-10 wrap">
      {!isLoading
        ? profile?.socials?.map((social) => (
            <SocialIconLink
              key={`${social.platform}_${social.identifier}`}
              social={social.platform}
              size={22}
              username={social.identifier}
            />
          ))
        : socialLoader?.map((social) => (
            <SocialIconLink
              key={`${social.platform}_${social.identifier}`}
              social={social.platform}
              size={22}
              isLoading={true}
              username={social.identifier}
            />
          ))}
    </div>
  )
}
